import { Tooltip, TooltipTrigger } from "@light-technology/components";
import { type ReactNode } from "react";

type PlanTypeIconProps = {
  title: string;
  inactiveTitle: string;
  children: ReactNode | ReactNode[];
  isActive: boolean;
};

export const PlanTypeIcon = ({
  title,
  inactiveTitle,
  children,
  isActive,
}: PlanTypeIconProps) => {
  return (
    <Tooltip title={isActive ? title : inactiveTitle} placement="bottom">
      <TooltipTrigger>
        <div className={isActive ? "" : "text-fg-disabled"}>{children}</div>
      </TooltipTrigger>
    </Tooltip>
  );
};
